import type { ResolvedContent } from '../content';
import { damagePlayer } from '../damage';
import { touches } from '../effects';
import type { SpecialModule } from '../specials/types';
import type { PlayerState, SimState } from '../state';

const SUN_LINGER_TICKS = 2;

function shaded(state: SimState, content: ResolvedContent, player: PlayerState): boolean {
  const within = (at: { x: number; y: number }, radius: number | undefined): boolean => {
    if (radius === undefined) {
      return false;
    }
    const dx = player.x - at.x;
    const dy = player.y - at.y;
    return dx * dx + dy * dy <= radius * radius;
  };
  return (
    state.players.some(
      (other) => !other.downed && within(other, content.classes.get(other.classId)?.shadeRadius),
    ) ||
    state.traps.some((trap) => within(trap, content.traps.get(trap.kind)?.shade)) ||
    (state.placed ?? []).some((zone) => within(zone, content.weapons.get(zone.weaponId)?.shade))
  );
}

export const heat: SpecialModule = ({ state, content }, enemy, effect) => {
  if (effect.kind !== 'heat') {
    return;
  }
  const onBeat = state.events.some((event) => event.type === 'beat');
  for (const player of state.players) {
    if (player.downed || !touches(player, enemy, effect.radius) || shaded(state, content, player)) {
      continue;
    }
    player.sunTicks = SUN_LINGER_TICKS;
    if (onBeat) {
      damagePlayer(state, player, effect.damage);
    }
  }
};
